import React, { useContext, useState } from "react";
import { Alert, Dialog, Table } from "../../layout";
import { Button } from "../../controls";
import { Avatar, IconButton, Tooltip } from "@mui/material";
import {
  ClearRounded,
  EditRounded,
  VisibilityRounded,
} from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import ViewBranch from "./ViewBranch";
import { AppContext } from "../../App";
import { API, endpoints } from "../../api/api";
import { Countries } from "../../hooks/Countries";
import { useTranslation } from "react-i18next";

const Branches = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { branch, branches, setBranches } = useContext(AppContext);
  const [viewBranch, setViewBranch] = useState(false);
  const [viewData, setViewData] = useState();
  const [alert, setAlert] = useState({
    isOpen: false,
    type: "",
    title: "",
    subTitle: "",
  });
  const handleAddEdit = (id) => {
    navigate(`/branch_form/${id || ""}`);
  };
  const handleView = (data) => {
    setViewBranch(true);
    setViewData(data);
  };

  const handleDlt = (id) => {
    if (id && branch.id !== id) {
      setAlert({
        isOpen: true,
        type: "confirmation",
        title: t("CfmTitle"),
        subTitle: t("BranchDltTitle"),
        onConfirm: () => {
          const onComplete = (res) => {
            if (res.status === 200) {
              setAlert({
                isOpen: true,
                type: "success",
                title: t("DltSuccessTitle"),
                subTitle: res.msg,
              });
              setBranches((x) => [...x.filter((j) => j.id !== res.result.id)]);
            } else {
              setAlert({
                isOpen: true,
                type: "warning",
                title: t("Warning"),
                subTitle: res.msg,
              });
            }
          };
          API(endpoints.Branch).Delete(id, onComplete);
        },
      });
    } else if (branch.id === id) {
      setAlert({
        isOpen: true,
        type: "warning",
        title: t("Warning"),
        subTitle: t("BranchDtlErrTitle"),
      });
    }
  };

  const ActionComp = (props) => (
    <div className="bs-secondary br-8 p-5 w-fit p-2">
      <Tooltip title={t("View")}>
        <IconButton
          onClick={() => handleView(props)}
          size="small"
          color="primary"
          className="mr-5 p-5"
        >
          <VisibilityRounded className="fs-18 m-2" />
        </IconButton>
      </Tooltip>

      <Tooltip title={t("Edit")}>
        <IconButton
          onClick={() => handleAddEdit(props.id)}
          size="small"
          color="primary"
          className="mr-5 p-5"
        >
          <EditRounded className="fs-20 m-2" />
        </IconButton>
      </Tooltip>

      <Tooltip title={t("Delete")}>
        <IconButton
          onClick={() => handleDlt(props.id)}
          size="small"
          color="error"
          className="mr-5 p-5"
        >
          <ClearRounded className="fs-20 m-2" />
        </IconButton>
      </Tooltip>
    </div>
  );
  const HeaderComp = () => (
    <div>
      <Button onClick={() => handleAddEdit()}>{t("AddBranch")}</Button>
    </div>
  );
  return (
    <>
      <Table
        ActionComp={ActionComp}
        HeaderComp={HeaderComp}
        tblHead={[
          { id: "branch", label: t("Branch") },
          { id: "contact", label: t("Contact") },
          { id: "countryDtl", label: t("Country") },
          { id: "address", label: t("Address") },
          { id: "actions", label: t("Actions") },
        ]}
        tblData={branches.map((j) => {
          var _country = Countries.find((x) => x.id === j.country);
          return {
            ...j,
            countryName: _country && _country.label,
            branch: (
              <div className="d-flex mt-5 mb-5">
                <div className="mr-30">
                  <Avatar src={j.logo} className="shadow-lg" />
                </div>
                <div className="d-grid ">
                  <span className="fs-16 fw-5 gray-color c-pointer">
                    {j.name}
                  </span>
                  <span className="fs-12 fw-4 gray-color c-pointer">
                    {t("BranchId")}: {j.id}
                  </span>
                </div>
              </div>
            ),
            contact: (
              <div className="d-grid ">
                <a
                  className="fs-14 primary-color c-pointer mb-3"
                  href={`mailto:${j.email}`}
                >
                  ✉️ {j.email}
                </a>
                <a
                  className="fs-14 primary-color c-pointer"
                  href={`tel:${j.phone}`}
                >
                  📞 {j.phone}
                </a>
              </div>
            ),
            countryDtl: (
              <div className="d-grid ">
                <span className="fs-16 fw-5 gray-color c-pointer">
                  {_country && _country.label}
                </span>
                <span className="fs-12 fw-4 gray-color c-pointer">
                  {j.currency}
                </span>
              </div>
            ),
            address: (
              <p className="fs-16 fw-4 gray-color c-pointer m-0 p-0">
                {j.address}
              </p>
            ),
          };
        })}
      />

      {/* View Details */}
      {viewBranch && (
        <Dialog show={viewBranch} onClose={false} maxWidth="md">
          <ViewBranch {...{ setShowForm: setViewBranch, viewData }} />
        </Dialog>
      )}

      {/* Alert  */}
      <Alert alert={alert} setAlert={setAlert} />
    </>
  );
};

export default Branches;
